module.exports = __webpack_public_path__ + "img/cheatsheet_icon_insider_gold_2x.dde35671.png";